import { Flow } from '@/types/flow';

export const sampleFlows: Flow[] = [
  {
    id: '1',
    name: 'Lead Qualification',
    description: 'Qualify inbound leads with a multi-step funnel',
    steps: [
      { id: 's1', type: 'headline', title: 'Tell us about yourself 👋', required: false },
      { id: 's2', type: 'input_field', title: 'What is your full name?', placeholder: 'John Doe', required: true },
      { id: 's3', type: 'email', title: 'What is your work email?', placeholder: 'john@company.com', required: true },
      { id: 's4', type: 'select', title: 'Company size?', options: [
        { id: 'o1', label: '1-10' }, { id: 'o2', label: '11-50' }, { id: 'o3', label: '51-200' }, { id: 'o4', label: '200+' }
      ]},
      { id: 's5', type: 'textarea', title: 'Tell us about your project', placeholder: 'Describe your needs...' },
      { id: 's6', type: 'submit_button', title: 'Submit' },
    ],
    createdAt: '2026-02-08',
    updatedAt: '2026-02-10',
    responses: 47,
    status: 'active',
  },
  {
    id: '2',
    name: 'Customer Feedback',
    description: 'Collect NPS and product feedback from customers',
    steps: [
      { id: 's1', type: 'icon_rating', title: 'How likely are you to recommend us?' },
      { id: 's2', type: 'multiple_choice', title: 'What did you like most?', options: [
        { id: 'o1', label: 'Ease of use' }, { id: 'o2', label: 'Features' }, { id: 'o3', label: 'Support' }, { id: 'o4', label: 'Pricing' }
      ]},
      { id: 's3', type: 'textarea', title: 'Any additional feedback?', placeholder: 'Share your thoughts...' },
      { id: 's4', type: 'submit_button', title: 'Submit' },
    ],
    createdAt: '2026-02-05',
    updatedAt: '2026-02-09',
    responses: 123,
    status: 'active',
  },
  {
    id: '3',
    name: 'Event Registration',
    description: 'Sign up attendees for upcoming webinar',
    steps: [
      { id: 's1', type: 'input_field', title: 'Your name', required: true },
      { id: 's2', type: 'email', title: 'Email address', required: true },
      { id: 's3', type: 'phone_number', title: 'Phone number (optional)' },
      { id: 's4', type: 'select', title: 'Which session?', options: [
        { id: 'o1', label: 'Morning (10 AM)' }, { id: 'o2', label: 'Afternoon (2 PM)' }, { id: 'o3', label: 'Evening (6 PM)' }
      ]},
      { id: 's5', type: 'continue_button', title: 'Register' },
    ],
    createdAt: '2026-02-01',
    updatedAt: '2026-02-03',
    responses: 8,
    status: 'draft',
  },
  {
    id: '4',
    name: 'Adelira Skincare Quiz',
    description: 'Persoonlijk huidadvies quiz met €60 korting',
    brandName: 'adelira',
    accentColor: '#2d6a4f',
    steps: [
      // Screen 1: Intro + leeftijd
      { id: 'a1', type: 'headline', title: 'Is jouw huid geschikt voor micro-infusie?', screenId: 'scr1', settings: { align: 'center' } },
      { id: 'a2', type: 'text', title: 'Ontdek het in 1 minuut + ontvang €60 korting op je eerste bestelling', screenId: 'scr1', settings: { align: 'center' } },
      { id: 'a3', type: 'multiple_choice', title: 'Wat is je leeftijd? 🤔', screenId: 'scr1', autoAdvance: true, options: [
        { id: 'o1', label: 'Onder 30' }, { id: 'o2', label: '30-39' }, { id: 'o3', label: '40-49' }, { id: 'o4', label: '50-59' }, { id: 'o5', label: 'Boven 60' }
      ]},
      { id: 'a3b', type: 'text', title: 'Door op een van de bovenstaande opties te klikken, ga je akkoord met de [Gebruiksvoorwaarden](https://adelira.nl/pages/gebruiksaanwijzing-ifu), [Servicevoorwaarden](https://adelira.nl/policies/terms-of-service) en het [Privacybeleid](https://adelira.nl/policies/privacy-policy).', screenId: 'scr1', settings: { align: 'center' }, design: { fontSize: 13 } },

      // Screen 2: Verbeteren (multi-select)
      { id: 'a4', type: 'multiple_choice', title: 'Wat wil je het liefst verbeteren? ✨', screenId: 'scr2', multiSelect: true, description: '(Selecteer alles wat van toepassing is)', options: [
        { id: 'o1', label: '😟 Rimpels en diepe lijnen' },
        { id: 'o2', label: '🙁 Fijne lijntjes rond ogen en mond' },
        { id: 'o3', label: '😔 Slappe, hangende huid' },
        { id: 'o4', label: '🤚 Crêpe-achtige textuur' },
        { id: 'o5', label: '🫣 Donkere vlekken of pigmentatie' },
        { id: 'o6', label: '😶 Doffe, vermoeid uitziende huid' },
        { id: 'o7', label: '✨ Alles - mijn huid voelt gewoon "oud"' },
      ]},

      // Screen 3: Rimpels diepte
      { id: 'a5', type: 'multiple_choice', title: 'Hoe diep zijn je rimpels?', screenId: 'scr3', autoAdvance: true, options: [
        { id: 'o1', label: 'Nauwelijks zichtbaar' }, { id: 'o2', label: 'Duidelijk zichtbaar' }, { id: 'o3', label: 'Diep en geprononceerd' }
      ]},

      // Screen 4: Waar werken (picture choice)
      { id: 'a6t', type: 'text', title: '(Kies alles wat van toepassing is)', screenId: 'scr4', settings: { align: 'center' } },
      { id: 'a6', type: 'picture_choice', title: 'Waar wil je aan werken? ✨', screenId: 'scr4', multiSelect: true, options: [
        { id: 'o1', label: 'Mondrimpels', imageUrl: 'https://assets.prd.heyflow.com/flows/Z5lpbNE82YEqEoyhQW8y/www/assets/21dce6ef-b11e-4ca2-9afb-8e8a5d6a7903/original.avif' },
        { id: 'o2', label: 'Voorhoofdrimpels', imageUrl: 'https://assets.prd.heyflow.com/flows/Z5lpbNE82YEqEoyhQW8y/www/assets/68b5fcf5-2ffc-46ae-8c72-b60cb4585872/original.avif' },
        { id: 'o3', label: 'Oogrimpels of kraaienpootjes', imageUrl: 'https://assets.prd.heyflow.com/flows/Z5lpbNE82YEqEoyhQW8y/www/assets/79ae5add-27cd-4af8-b008-e5202ae1b12d/original.avif' },
        { id: 'o4', label: 'Hals en kaaklijn', imageUrl: 'https://assets.prd.heyflow.com/flows/Z5lpbNE82YEqEoyhQW8y/www/assets/528187a0-5ff3-4825-9e49-c31a794f34aa/original.avif' },
      ]},

      // Screen 5: Social proof
      { id: 'a7', type: 'headline', title: 'Je bent in goede handen', screenId: 'scr5', settings: { align: 'center' } },
      { id: 'a7b', type: 'text', title: '5.800+ vrouwen hebben hun huid zichtbaar verbeterd met het Adelira SkinFuse® Micro-Infusion Systeem.\n\nZonder injecties, zonder dure kliniekbezoeken.', screenId: 'scr5', settings: { align: 'center' } },
      { id: 'a7img', type: 'photo_carousel', title: '', screenId: 'scr5', images: [
        '/images/carousel-1.avif',
        '/images/carousel-2.avif',
        '/images/carousel-3.avif',
        '/images/carousel-4.avif',
        '/images/carousel-5.avif',
        '/images/carousel-6.avif',
      ]},
      { id: 'a7c', type: 'continue_button', title: 'VOLGENDE', screenId: 'scr5' },

      // Screen 6: Zon
      { id: 'a8', type: 'multiple_choice', title: 'Hoe vaak kom je in de zon? ☀️', screenId: 'scr6', autoAdvance: true, options: [
        { id: 'o1', label: '☀️ Dagelijks' }, { id: 'o2', label: '🌤️ Regelmatig' }, { id: 'o3', label: '⛅ Af en toe' }, { id: 'o4', label: '☁️ Zelden of nooit' }, { id: 'o5', label: '🤷‍♀️ Ik weet het niet zeker' }
      ]},

      // Screen 7: Slaap
      { id: 'a9', type: 'multiple_choice', title: 'Hoeveel slaap krijg je meestal? 💤', screenId: 'scr7', autoAdvance: true, options: [
        { id: 'o1', label: '😴 Meer dan 8 uur' }, { id: 'o2', label: '🙂 7-8 uur' }, { id: 'o3', label: '😐 6-7 uur' }, { id: 'o4', label: '😟 Minder dan 6 uur' }, { id: 'o5', label: '🔄 Wisselend / onvoorspelbaar' }
      ]},

      // Screen 8: Stress
      { id: 'a10', type: 'multiple_choice', title: 'Hoe vaak ervaar je stress? 😓', screenId: 'scr8', autoAdvance: true, options: [
        { id: 'o1', label: '😰 Dagelijks / constant' }, { id: 'o2', label: '😐 Regelmatig, vooral op werk' }, { id: 'o3', label: '🙂 Soms, in drukke periodes' }, { id: 'o4', label: '😎 Zelden of nooit' }
      ]},

      // Screen 9: Huidtint (picture choice)
      { id: 'a11', type: 'multiple_choice', title: 'Wat is je huidtint?', screenId: 'scr9', autoAdvance: true, options: [
        { id: 'o1', label: 'Zeer licht', imageUrl: '/images/skin-zeer-licht.avif' },
        { id: 'o2', label: 'Licht', imageUrl: '/images/skin-licht.avif' },
        { id: 'o3', label: 'Medium', imageUrl: '/images/skin-medium.avif' },
        { id: 'o4', label: 'Donker', imageUrl: '/images/skin-donker.avif' },
        { id: 'o5', label: '❓ Weet ik niet zeker' },
      ]},

      // Screen 10: Gevoeligheid
      { id: 'a12', type: 'multiple_choice', title: 'Hoe gevoelig is je huid?', screenId: 'scr10', autoAdvance: true, options: [
        { id: 'o1', label: 'Zeer gevoelig – Reageert op veel producten' },
        { id: 'o2', label: 'Een beetje gevoelig – Soms irritatie' },
        { id: 'o3', label: 'Niet gevoelig – Verdraagt alles prima' },
      ]},

      // Screen 11: Match + loader
      { id: 'a13', type: 'headline', title: 'Je bent een match! ✅', screenId: 'scr11', settings: { align: 'center' } },
      { id: 'a13b', type: 'text', title: 'Op basis van jouw antwoorden is Adelira geschikt voor jouw huid. We hebben een persoonlijk plan samengesteld. Ontdek nu je behandelplan. 👇', screenId: 'scr11', settings: { align: 'center' } },
      { id: 'a14', type: 'loader', title: 'Jouw antwoorden analyseren...', screenId: 'scr11', loaderSteps: ['📊 Jouw antwoorden analyseren...', '🔬 Huidprofiel samenstellen...', '✨ Behandelplan personaliseren...', '✅ Jouw advies is klaar!'], loaderDuration: 6000 },

      // Screen 11b: Samenvatting huidprofiel
      { id: 'a14b', type: 'skin_profile_summary', title: 'Samenvatting van jouw huidprofiel', screenId: 'scr11b' },
      { id: 'a14c', type: 'continue_button', title: 'VOLGENDE', screenId: 'scr11b' },

      // Screen 12: Eerdere oplossingen
      { id: 'a15', type: 'multiple_choice', title: 'Welke oplossingen heb je eerder geprobeerd?', screenId: 'scr12', multiSelect: true, description: '(Selecteer alles wat van toepassing is)', options: [
        { id: 'o1', label: '🧴 Anti-aging crèmes of serums' },
        { id: 'o2', label: '💊 Supplementen of poeders' },
        { id: 'o3', label: '🌿 Natuurlijke huismiddeltjes' },
        { id: 'o4', label: '💉 Professionele behandelingen (botox, fillers)' },
        { id: 'o5', label: '🤷‍♀️ Nog niks geprobeerd' },
      ]},

      // Screen 13: Info screen
      { id: 'a16h', type: 'headline', title: 'Waarom de meeste oplossingen niet werken..', screenId: 'scr13', settings: { align: 'center' } },
      { id: 'a16', type: 'text', title: 'Veel huidverzorgingsproducten blijven aan de oppervlakte – ze dringen niet diep genoeg door om echt resultaat te geven.\n\n**Maar hier zit het probleem:** Collageen wordt aangemaakt in de diepere huidlagen. Crèmes die bovenop blijven liggen, bereiken dit nooit.\n\n**Adelira\'s Micro-Infusion System** brengt actieve ingrediënten rechtstreeks waar ze nodig zijn – zonder naalden, zonder kliniek.\n\n**Geen enkel ander thuissysteem doet dit.**', screenId: 'scr13', settings: { align: 'left' } },
      { id: 'a16img', type: 'image', title: 'Adelira Kit', screenId: 'scr13', imageUrl: '/images/adelira-kit-marble.png' },
      { id: 'a16c', type: 'continue_button', title: 'VOLGENDE', screenId: 'scr13' },

      // Screen 14: Tijd
      { id: 'a17', type: 'multiple_choice', title: 'Hoeveel tijd kun je besteden aan huidverzorging? ⏱️', screenId: 'scr14', autoAdvance: true, options: [
        { id: 'o1', label: '⚡ Zo min mogelijk – max 5 minuten' },
        { id: 'o2', label: '🕐 5-10 minuten is prima' },
        { id: 'o3', label: '⌛ Ik neem er graag de tijd voor (15+ min)' },
      ]},

      // Screen 15: Info
      { id: 'a18h', type: 'headline', title: 'Het kost je maar 5 minuten – eens per 2 weken', screenId: 'scr15', settings: { align: 'center' } },
      { id: 'a18', type: 'text', title: 'Een stralende huid hoeft niet ingewikkeld te zijn.\n\nMet Adelira\'s Micro-Infusion System behandel je thuis in **slechts 5 minuten**. Niet dagelijks – maar **één keer per twee weken.**\n\nLaat de actieve ingrediënten het werk doen.', screenId: 'scr15', settings: { align: 'left' } },
      { id: 'a18img', type: 'image', title: 'Adelira gebruiker', screenId: 'scr15', imageUrl: '/images/adelira-gebruiker-vrouw.png' },
      { id: 'a18c', type: 'continue_button', title: 'VOLGENDE', screenId: 'scr15' },

      // Screen 16: Gevoel
      { id: 'a19', type: 'multiple_choice', title: 'Heb je ooit het gevoel gehad dat je huid je ouder doet lijken dan je je van binnen voelt? 🤔', screenId: 'scr16', autoAdvance: true, options: [
        { id: 'o1', label: '😔 Ja, regelmatig' }, { id: 'o2', label: '😐 Soms, af en toe' }, { id: 'o3', label: '😊 Nee, niet echt' }
      ]},

      // Screen 17: Stralende versie
      { id: 'a20', type: 'multiple_choice', title: 'Hoe zou het voelen om weer een stralende, jongere versie van jezelf in de spiegel te zien?', screenId: 'scr17', autoAdvance: true, options: [
        { id: 'o1', label: '🔥 Ik zou me zelfverzekerder voelen' },
        { id: 'o2', label: '👍 Ik zou trots zijn op mezelf' },
        { id: 'o3', label: '✨ Ik zou me aantrekkelijker voelen' },
        { id: 'o4', label: '💫 Alle bovenstaande' },
      ]},

      // Screen 18: Gelegenheid
      { id: 'a21', type: 'multiple_choice', title: 'Heb je binnenkort een belangrijke gelegenheid?', screenId: 'scr18', autoAdvance: true, description: 'Iets hebben om naar uit te kijken kan een grote motivatie zijn om je doel te bereiken', options: [
        { id: 'o1', label: '🎂 Verjaardag' }, { id: 'o2', label: '🏖️ Vakantie' }, { id: 'o3', label: '👫 Reünie of feest' },
        { id: 'o4', label: '📸 Fotoshoot of evenement' }, { id: 'o5', label: '💍 Bruiloft of jubileum' }, { id: 'o6', label: '🤷‍♀️ Nee, geen specifieke planning' },
      ]},

      // Screen 18b: Resultaten klaar - transitie
      { id: 'a21b_h', type: 'headline', title: 'Over enkele weken ziet je huid er zichtbaar jonger uit', screenId: 'scr18b', settings: { align: 'center' } },
      { id: 'a21b_t', type: 'text', title: 'Op basis van jouw antwoorden, dit is wat je kunt verwachten:\n\n**✅ Eerste verbetering:** Binnen 2-3 weken\n\n**✅ Zichtbare transformatie:** Na 8 weken', screenId: 'scr18b', settings: { align: 'center' } },
      { id: 'a21b_loader', type: 'list_loader', title: 'Je resultaten zijn klaar!', screenId: 'scr18b', loaderSteps: ['Antwoorden analyseren...', 'Huidprofiel berekenen...', 'Persoonlijk plan samenstellen...', 'Je resultaten zijn klaar!'], loaderDuration: 4000 },

      // Screen 19: Results
      { id: 'a22', type: 'text', title: 'Gebaseerd op je antwoorden:', screenId: 'scr19', settings: { align: 'center' } },
      { id: 'a22h', type: 'headline', title: 'Ben je slechts 3 maanden verwijderd van volledig verjongde huid!', screenId: 'scr19', settings: { align: 'center' } },
      { id: 'a22t', type: 'text', title: 'Dit kun je verwachten:\n\n✅ Zichtbare resultaten na slechts één behandeling\n✅ Verwijderde rimpels en volledig strakke huid tot {{TARGET_DATE}}', screenId: 'scr19', settings: { align: 'center' } },
      { id: 'a22ba', type: 'before_after', title: '', screenId: 'scr19' },
      { id: 'a23', type: 'continue_button', title: 'CLAIM JE KORTING', screenId: 'scr19', linkUrl: 'https://adelira.nl/products/skinfuse-infusion-kit' },
    ],
    screens: [
      { id: 'scr1', name: 'Intro + Leeftijd', stepIds: ['a1', 'a2', 'a3', 'a3b'] },
      { id: 'scr2', name: 'Verbeteren', stepIds: ['a4'] },
      { id: 'scr3', name: 'Rimpels', stepIds: ['a5'] },
      { id: 'scr4', name: 'Waar werken', stepIds: ['a6t', 'a6'] },
      { id: 'scr5', name: 'Social proof', stepIds: ['a7', 'a7b', 'a7img', 'a7c'] },
      { id: 'scr6', name: 'Zon', stepIds: ['a8'] },
      { id: 'scr7', name: 'Slaap', stepIds: ['a9'] },
      { id: 'scr8', name: 'Stress', stepIds: ['a10'] },
      { id: 'scr9', name: 'Huidtint', stepIds: ['a11'] },
      { id: 'scr10', name: 'Gevoeligheid', stepIds: ['a12'] },
      { id: 'scr11', name: 'Match + Loader', stepIds: ['a13', 'a13b', 'a14'] },
      { id: 'scr11b', name: 'Huidprofiel samenvatting', stepIds: ['a14b', 'a14c'] },
      { id: 'scr12', name: 'Eerdere oplossingen', stepIds: ['a15'] },
      { id: 'scr13', name: 'Info', stepIds: ['a16h', 'a16', 'a16img', 'a16c'] },
      { id: 'scr14', name: 'Tijd', stepIds: ['a17'] },
      { id: 'scr15', name: 'Info 2', stepIds: ['a18h', 'a18', 'a18img', 'a18c'] },
      { id: 'scr16', name: 'Gevoel', stepIds: ['a19'] },
      { id: 'scr17', name: 'Stralende versie', stepIds: ['a20'] },
      { id: 'scr18', name: 'Gelegenheid', stepIds: ['a21'] },
      { id: 'scr18b', name: 'Resultaten klaar', stepIds: ['a21b_h', 'a21b_t', 'a21b_loader'] },
      { id: 'scr19', name: 'Resultaten', stepIds: ['a22', 'a22h', 'a22t', 'a22ba', 'a23'] },
      
    ],
    createdAt: '2026-02-10',
    updatedAt: '2026-02-11',
    responses: 0,
    status: 'draft',
  },
];
